<template>
  <div class="company-information">
    <Tablist
      :list="tabList"
      :active-id="activeIndex"
      @updateCurrentPage="updateCurrentPage"
    />
    <div class="tuolele-main-box">
      <el-form
        v-if="activeIndex == 1"
        ref="form"
        label-width="120px"
        class="company-form"
      >
        <el-form-item label="公司名称">
          <span class="color-black">{{ companyInfo.company_name }}</span>
        </el-form-item>
        <el-form-item label="名牌简称">
          <span class="color-black">{{ companyInfo.extra.short_name }}</span>
        </el-form-item>
        <el-form-item label="公司logo">
          <UploadImg
            :photo.sync="photo.logo_url"
            :name="'logo_url'"
            @updateImg="updatePhoto"
          />
          <div class="upload-notice">请上传200*200像素的图片</div>
        </el-form-item>
        <el-form-item label="公司Slogen">
          <el-input
            v-model="companyInfo.extra.slogen"
            clearable
            placeholder="请输入公司Slogen"
          />
        </el-form-item>
        <el-form-item label="客服电话">
          <!-- <el-input clearable v-model="companyInfo.name" placeholder="区号" class="company-areacode"></el-input>- -->
          <el-input
            v-model="companyInfo.extra.telephone"
            clearable
            placeholder="客服电话"
            class="company-tele"
          />
        </el-form-item>
        <el-form-item label="官网链接">
          <el-input
            v-model="companyInfo.extra.show_url"
            clearable
            placeholder="请输入官网地址"
          />
          <div class="upload-notice">如没有官网，可添加公司介绍软文链接</div>
        </el-form-item>
        <el-form-item label="账号开通时间">
          <span class="color-black">{{ companyInfo.create_time }}</span>
        </el-form-item>
        <!-- <el-form-item label="使用截止日期">
          <span class="color-black">{{ companyInfo.expiration_time }}</span>
        </el-form-item> -->
        <el-form-item class="form-buttom">
          <el-button
            type="primary"
            class="el-button-confirm"
            @click="improveCompany"
          >保存</el-button>
        </el-form-item>
      </el-form>
      <div v-if="activeIndex==0">
        <el-button style="margin-bottom:10px" type="primary" @click="fnEditAguremnt()">创建合同</el-button>
        <el-table :data="argumentLists" border stripe>
          <el-table-column label="合同名称" prop="title" align="center" />
          <el-table-column label="修改时间" prop="modify_time" align="center" />
          <el-table-column label="套餐类型" show-overflow-tooltip prop="order_type_name" align="center" />
          <el-table-column label="操作" align="center">
            <template slot-scope="{row}">
              <el-button type="text" @click="fnEditAguremnt(row)">编辑合同</el-button>
              <el-button type="text" @click="fnOpenPage(row.id)">预览</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>
  </div>
</template>

<script>
import Tablist from '@/components/toolbar/Tablist.vue'
import UploadImg from '@/components/toolbar/UploadImg.vue'
export default {
  name: 'CompanyInformation',
  components: {
    Tablist,
    UploadImg
  },
  data() {
    return {
      tabList: [
        // { id: '1', directory_name: '公司信息' },
        { id: '0', directory_name: '合同信息' }
      ],
      activeIndex: '0',
      photo: {
        logo_url: '',
        chapter_url: ''
      },
      step: {
        step11: [],
        step12: [],
        step13: []
      },
      argumentLists: [],
      companyInfo: {
        company_name: '',
        company_summary: '',
        extra: {
          contract_terms: {
            step1: [],
            step2: [],
            step3: [],
            step4: []
          },
          telephon: '',
          show_url: '',
          logo_url: '',
          slogen: '',
          chapter_url: ''
        }
      }

    }
  },
  mounted() {
    this.getCompanyInfo()
    this.getContractList()
  },
  methods: {
    updateCurrentPage(val) {
      this.activeIndex = val
    },
    updatePhoto(photo, name) {
      this.photo[name] = photo
    },
    addStepInput(val) {
      this.companyInfo.extra.contract_terms[val].push({ value: '' })
    },
    fnOpenPage(id) {
      window.open(`https://cms.tuolele.cn/api/company/contractPreview?id=${id}`)
    },
    getCompanyInfo() {
      this.$http.getCompanyInfo().then(res => {
        if (res.code == 200) {
          this.companyInfo = res.data
          this.photo.logo_url = this.companyInfo.extra.logo_url
          this.photo.chapter_url = this.companyInfo.extra.chapter_url
        }
      })
    },
    getContractList() {
      this.$http.getContractList().then(res => {
        if (res.code == 200) {
          this.argumentLists = res.data
        }
      })
    },
    fnEditAguremnt(argument) {
      this.$router.push({
        path: 'companyArgument',
        query: { id: argument && argument.id }
      })
    },
    improveCompany() {
      const companyInfo = {
        telephone: this.companyInfo.extra.telephone,
        show_url: this.companyInfo.extra.show_url,
        logo_url: this.photo.logo_url,
        slogen: this.companyInfo.extra.slogen,
        chapter_url: this.photo.chapter_url,
        contract_terms: JSON.stringify(this.companyInfo.extra.contract_terms)
      }
      this.$http.improveCompany(companyInfo).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '保存成功'
          })
          this.getCompanyInfo()
        }
      })
    }
  }
}
</script>
<style lang="scss">
.company-information {
  .el-input,
  .el-textarea {
    width: 310px;
  }
  span.color-black {
    display: block;
  }
  .company-areacode {
    width: 80px;
  }
  .company-tele {
    width: 210px;
  }
  .el-textarea {
    width: 800px;
    margin-bottom: 10px;
  }
  .student-rules {
    span {
      margin-left: 8px;
      line-height: 25px;
    }
    .el-textarea {
      margin-left: 8px;
      margin-top: 8px;
    }
  }
  .contract-form .form-buttom {
    .el-form-item__content {
      margin-left: 165px !important;
    }
  }
  .company-form .form-buttom {
    .el-form-item__content {
      margin-left: 130px !important;
    }
  }
  .about-refund {
    width: 820px;
    font-size: 15px;
    line-height: 24px;
    margin-left: 8px;
    margin-top: 8px;
  }
}
</style>
